import * as React from 'react'
import { useTranslation } from 'react-i18next'

import PdfViewer from '../../pures/syncFusionPdfViewer/pdf-viewer'
import './pdf-viewer.action.css'

/**
 * @typedef {object} Props
 * @prop {string} url
 * @prop {boolean} isExtended
 * @prop {boolean} isSSRActive
 * @prop {string} customHeight
*/

/**
 * @author Marissa Vargas
 * @date 2025-05-15
 * @description Action component to wrap the PdfViewer from SyncFusion. It handles load failing.
 * @param {Props}
 * @returns {JSX.Element}
 * @example
 * ```jsx
 *  <PdfViewerAction url={props.url} />
 * ```
 * @see https://ej2.syncfusion.com/documentation/api/pdfviewer/#documentloadfailed
 * @see https://ej2.syncfusion.com/documentation/api/pdfviewer/loadFailedEventArgs/
 */
function PdfViewerAction({ url, isExtended, isSSRActive, customHeight }) {
  const { t } = useTranslation()

  const [errorMessage, setErrorMessage] = React.useState('')

  const handleDocumentLoadFailed = (args) => {
    if (args.isPasswordRequired) {
      setErrorMessage(t('pdfViewer.errors.passwordRequired'))
    } else {
      setErrorMessage(t('pdfViewer.errors.loadFailed'))
    }
    console.error('PDF Error:', args.documentName, args.name)
  }

  if (!url || url.trim() === '') {
    return (
      <div className='pdfViewerAction-div'>
        <p className='pdfViewerAction-message'>{t('pdfViewer.errors.noUrl')}</p>
      </div>
    )
  }

  if (errorMessage !== '') {
    return (
      <div className='pdfViewerAction-div'>
        <p className='pdfViewerAction-message'>{errorMessage}</p>
      </div>
    )
  }

  return <PdfViewer url={url} isSSRActive={isSSRActive} documentLoadFailed={handleDocumentLoadFailed} t={t} isExtended={isExtended} customHeight={customHeight}
  />
}

export default PdfViewerAction
